const LoginForgotLogin = function () {
  this.init = function () {
    const form = document.getElementById('forgot-login-form');
    form.addEventListener('submit', () => {
      const forgotLoginId = $('#forgot-login-submit');
      const valueProcessing = $(forgotLoginId).data('valueProcessing');
      $(forgotLoginId).prop('disabled', 'true').html(valueProcessing);
    });
  }
}

const loginForgotLogin = new LoginForgotLogin();
